<template>
  <section>
    <v-container>
      <v-row>
        <div class="heading">
          <span>Les avantages</span>
          <p>
            Sportopia met à votre disposition un professionnel du coaching
            sportif, diplômé et rigoureusement sélectionné, garant d’une méthode
            efficace axée sur le suivi constant de ses clients.
          </p>
        </div>
      </v-row>
      <v-row>
        <v-col xs="12" sm="12" md="6" lg="4" class="responsive-pad">
          <div class="item">
            <span>Sécurité de paiement</span>
            <p>
              Paiement en ligne par carte bancaire
            </p>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="6" lg="4" class="responsive-pad">
          <div class="item">
            <span>Experience unique</span>
            <p>
              Notre solution de coaching en ligne est bien développée pour votre bien-être
            </p>
          </div>
        </v-col>
        <v-col xs="12" sm="12" md="6" lg="4" class="responsive-pad">
          <div class="item">
            <span>Efficacité des programmes</span>
            <p>
              Un programme 100% personnalisé avec des coachs bien sélectionnés sur des critères mises par l'équipe Sportopia
            </p>
          </div>
        </v-col>
      </v-row>
    </v-container>
  </section>
</template>

<script>
export default {
  name: "AppAvantages",
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css?family=Lato:300,400|Poppins:300,400,800&display=swap");
@import url("./../../assets/css/main-css.css");
section {
  background: #f5f5f5;
  padding: 50px 0;
  text-align: center;
}
.heading {
  margin: 0 auto 35px auto;
}
.heading span {
  font-size: 28px;
  font-weight: 600;
  display: block;
}
.heading p {
  font-size: 16px;
  font-weight: normal;
}
.item {
  background: #e8e8e8;
  padding: 70px 40px;
  border-radius: 30px;
  margin: 0px 30px;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.13), 0 10px 10px rgba(0, 0, 0, 0.1);
}
.item span {
  display: block;
  font-size: 21px;
  font-weight: bold;
  color: #e91e24;
  margin-bottom: 20px;
}
.item p {
  color: #000;
  font-weight: 500;
  margin-bottom: 0px;
}
</style>